// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';
import uuidv4 from 'uuid/v4';

import { withStyles } from '@material-ui/core/styles';

import moment from 'moment';
import styles from './styles';
import arrowRight from '../../../../../../../../images/arrowRight.png';


class VoucherHistory extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    vouchers: PropTypes.array,
  };

  static defaultProps = {
    classes: {},
    vouchers: [],
  };

  getDate = (date) => {
    // Explicit format, not 'L' - that follows moment's locale and renders
    // US MM/DD/YYYY by default, which read as the wrong date to UK shops.
    return moment(date).format('DD/MM/YYYY');
  };

  renderDesktopVoucher = (voucher) => {
    const { classes } = this.props;

    return (
      <div key={uuidv4()} className={classes.row}>
        <p className={classes.text}>{`${voucher.Code}`}</p>
        <p className={classes.text}>{`£${parseFloat(voucher.IssueValue).toFixed(2)}`}</p>
        <p className={classes.text}>{`${this.getDate(voucher.IssueDate)}`}</p>
        <p className={classes.text}>{`${voucher.OrderId}`}</p>
        <div className={classes.buttonContainer}>
          <Link
            className={classes.button}
            to={{
              pathname: `/account/vouchers/voucher/${voucher.Id}`,
              state: { voucherId: voucher.Id }
            }}
          >
            <img className={classes.arrowRight} src={arrowRight} alt={'details'} />
          </Link>
        </div>
      </div>
    );
  }

  renderMobileVoucher = (voucher) => {
    const { classes } = this.props;

    return (
      <div key={uuidv4()} className={classes.mobileRowContainer}>
        <div className={classes.column}>
          <div className={classes.row}>
            <p className={classes.descText}>Value:&nbsp;</p>
            <p className={classes.text}>{`£${parseFloat(voucher.IssueValue).toFixed(2)}`}</p>
          </div>
          <div className={classes.row}>
            <p className={classes.descText}>Date:&nbsp;</p>
            <p className={classes.text}>{`${this.getDate(voucher.IssueDate)}`}</p>
          </div>
          <div className={classes.row}>
            <p className={classes.descText}>Order no:&nbsp;</p>
            <p className={classes.text}>{`${voucher.OrderId}`}</p>
          </div>
        </div>
        <div className={classes.column}>
          <p className={classes.text}>{`${voucher.Code}`}</p>
        </div>
        <div className={classes.column}>
          <div className={classes.buttonContainer}>
            <Link
              className={classes.button}
              to={{
                pathname: `/account/vouchers/voucher/${voucher.Id}`,
                state: { voucherId: voucher.Id }
              }}
            >
              <img className={classes.arrowRight} src={arrowRight} alt={'details'} />
            </Link>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      classes,
      vouchers,
    } = this.props;

    // Order follows the cells below - and the mobile layout, which labels
    // Value before Date. The headers used to read date-then-value while the
    // rows rendered value-then-date, so both columns looked wrong.
    const headers = ['code', 'value', 'date', 'order no', 'details'];

    return (
      <div className={classes.container}>
        <MediaQuery minWidth={500}>
          { matches => (matches ? (
            <div>
              <div className={classes.row}>
                {headers.map(header => (
                  <p key={uuidv4()} className={classes.descText}>
                    {`${header}`}
                  </p>
                ))}
              </div>
              <div>
                {Array.from(vouchers).reverse().map(voucher => this.renderDesktopVoucher(voucher))}
              </div>
            </div>
          ) : (
            <div>
              {Array.from(vouchers).reverse().map(voucher => this.renderMobileVoucher(voucher))}
            </div>
          ))}
        </MediaQuery>
      </div>
    );
  }
}

export default (withStyles(styles)(VoucherHistory));
